import { useNavigate } from 'react-router-dom';
import { ShieldX } from 'lucide-react';
import useTenantState from '@/states/tenant.state';

export const AccessDenied = () => {
  const navigate = useNavigate();
  const { currentTenant } = useTenantState();

  const handleBackToWorkspaces = () => {
    const { removeCurrentTenant } = useTenantState.getState();
    removeCurrentTenant();
    navigate('/workspaces');
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen  px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="flex justify-center mb-6">
          <div className="bg-red-100 rounded-full p-4">
            <ShieldX className="w-16 h-16 text-red-600" />
          </div>
        </div>

        <h1 className="text-2xl font-bold text-gray-900 mb-4">Access Denied</h1>

        <p className="text-gray-600 mb-6">
          You don't have permission to access <span className="font-semibold">{currentTenant?.name}</span> workspace.
        </p>

        <button
          onClick={handleBackToWorkspaces}
          className="w-full bg-primary hover:bg-primary/90 text-white font-medium py-3 px-4 rounded-lg transition-colors duration-200"
        >
          Back to Workspaces
        </button>
      </div>
    </div>
  );
};
